import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';
// Vue.use(ElementUI);
Vue.use(ElementUI,{locale});

// 全局引用axios
import http from './http'
Vue.prototype.$http = http

var vm=new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
